import { defineComponent as _defineComponent } from 'vue'
import { computed, watch } from 'vue';
import CardExpand from '@/views/components/CardExpand.vue';
import { mdiInformation } from '@mdi/js';
import AutocompleteGraphql from '@/views/components/autocompletes/AutocompleteGraphql.vue';
import { GET_BOLETINS, GET_RELATORES } from '@/queries';
import { ConsultaBoletinsStore } from '../../store/ConsultaBoletinsStore';
import { storeToRefs } from 'pinia';
import { onKeyDownPreventNonNumbers } from '@/utils/util';
import { format, parseISO } from 'date-fns';
import { cloneDeep } from '@apollo/client/utilities';


export default /*#__PURE__*/_defineComponent({
  __name: 'CardMaisFiltros',
  setup(__props) {

const store = ConsultaBoletinsStore();

const { filtroBoletins, tiposBoletins, temFiltroBoletimComFlagJurisprudencia } =
  storeToRefs(store);

const { setDataPublicacaoInicio, setDataPublicacaoFim } = store;

const dataPublicacaoInicio = computed(() => {
  const dtPublicacaoInicio = cloneDeep(filtroBoletins.value.dtPublicacaoInicio);
  return dtPublicacaoInicio ? format(parseISO(dtPublicacaoInicio), 'yyyy') : '';
});

const dataPublicacaoFim = computed(() => {
  const dtPublicacaoFim = cloneDeep(filtroBoletins.value.dtPublicacaoFim);
  return dtPublicacaoFim ? format(parseISO(dtPublicacaoFim), 'yyyy') : '';
});

watch(temFiltroBoletimComFlagJurisprudencia, () => {
  if (!temFiltroBoletimComFlagJurisprudencia.value) {
    filtroBoletins.value = {
      ...filtroBoletins.value,
      relator: undefined,
      dtJulgamentoInicio: undefined,
      dtJulgamentoFim: undefined,
    };
  }
});

return { __sfc: true,store, filtroBoletins, tiposBoletins, temFiltroBoletimComFlagJurisprudencia, setDataPublicacaoInicio, setDataPublicacaoFim, dataPublicacaoInicio, dataPublicacaoFim, CardExpand, mdiInformation, AutocompleteGraphql, GET_BOLETINS, GET_RELATORES, onKeyDownPreventNonNumbers }
}

})